import { uniqBy } from "lodash";

import type { OwnerDetails } from "~/v2/api/rest/account";

export type AgreementEntry = NonNullable<OwnerDetails["esign_audit"]>[number];

export const filterAgreements = (
  esignAudit: OwnerDetails["esign_audit"],
  agreementName: string,
): AgreementEntry[] =>
  uniqBy(
    esignAudit?.filter(({ agreement }) => agreement === agreementName) ?? [],
    "revision",
  );
